export const SessionReasonConstant = {
  INVALID: 'session-invalid',
  EVICTED: 'session-evicted'
} as const;